import * as R from 'ramda';
import { whereEquals } from './whereEquals';
export const includesWhereObjEquals = R.curry((obj, arr) => R.any(whereEquals(obj), arr));
